import { getSdkVersionsDetailsQuery } from '@gonfalon/rest-api/queries/usage';
import { useSuspenseQuery } from '@tanstack/react-query';

export function useSdkVersionsDetails() {
  return useSuspenseQuery(getSdkVersionsDetailsQuery({ apiVersion: 'beta' }));
}
